<template>

  <t-page>

    <TypeCustomerDialog :no-option-add="noOptionAdd" @onSubmit="onTypeCustomerDialog"/>
    <GroupCostumerDialog :no-option-add="noOptionAdd" @onSubmit="onGroupCostumerDialog"/>
    <TypeOriginCustomerDialog :no-option-add="noOptionAdd" @onSubmit="onTypeOriginCustomerDialog"/>


    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">



        <t-form-tab title="Dados Básicos" active>

          <t-input v-model="form.customerId" hidden/>


          <t-form-card title="Cadastro" icon-building>

            <e-person :person="form.person" not-required name-required :command="command" address-relation-name="addressDefault"
                      :error="error_person" :status="status" @getApi="getEmbedCNPJApi">

              <b-row>

                <t-input v-model="form.customerNumber" label="Cód. Cliente" cols="2" fixed/>

                <t-input
                    cols="2"
                    v-model="form.otherCodeLabel"
                    :add-error="error.otherCodeLabel"
                    label="Cód. Interno"
                    help="Utilize este campo caso desejar armazenar o código deste cliente de outro sistema seu como por exemplo o ERP da sua empresa"/>


                <t-input v-model="form.typeCustomerId" cols="4"
                         required
                         :options="typeCustomerOptions" :add-error="error.typeCustomerId"
                         label="Perfil" select>

                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-type-customer',search)">Cadastrar Perfil de Cliente</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Perfil de Cliente" @click="openDialogForm('modal-type-customer')"
                              icon-plus/>
                  </template>

                </t-input>

                <t-input v-model="form.customerGroupId" cols="4"
                         :options="customerGroupOptions" :add-error="error.customerGroupId"

                         label="Grupo de Clientes"
                         help="Utilize o grupo de clientes para agrupar diferentes filiais em um único local, podendo centralizar preferências pela matriz."
                         select>

                  <template #no-options="{search}">
                    <b-link @click="addNoOption('modal-group-customer',search)">Cadastrar Grupo de Cliente</b-link>
                  </template>

                  <template #input-group-append>
                    <t-button title="Adicionar Grupo de Cliente" @click="openDialogForm('modal-group-customer')"
                              icon-plus/>
                  </template>

                </t-input>

              </b-row>

            </e-person>


            <e-address :address="form.addressDefault" not-required :command="command" name="addressDefault"
                       :status="status"
                       @getApi="getEmbedAddressApi"/>

          </t-form-card>

          <t-form-card title="Alçada de Acesso" icon-folder>

            <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="form.enableAllCompanies" switch>
              Habilitar todas empresas a este cliente?
              <t-help
                  title="Você poderá especificar quais as empresas desejadas, basta desmarcar esta opção e especificar quais as empresas abaixo."/>
            </b-form-checkbox>

            <t-table
                v-if="!form.enableAllCompanies"
                enable-checked
                v-model="companiesIds"
                :items="companiesList"
                :fields="viewFieldsPageCompanies"
                title-items="empresa"
                link-primary-column="name"
                table-bordered
                disable-actions-column
                primary-key-column="companyId">

              <template #first-column="{item}">
                {{ item.name }}
              </template>

            </t-table>

          </t-form-card>

          <t-form-card title="Informações Adicionais" icon-info-square>

            <b-row>


              <t-input v-model="form.typeOriginCustomerId" cols="4"
                       :options="typeOriginCustomerOptions"
                       first-default
                       required
                       label="Origem do Cliente" select>

                <template #no-options="{search}">
                  <b-link @click="addNoOption('modal-type-origin-customer',search)">Cadastrar Origem</b-link>
                </template>

                <template #input-group-append>
                  <t-button title="Adicionar nova Origem" @click="openDialogForm('modal-type-origin-customer')"
                            icon-plus/>
                </template>

              </t-input>

              <t-input v-model="form.priceListId"
                       cols="4"
                       :required="getRenderRule('requiredPriceList')"
                       :options="priceListOptions"
                       label="Tabela de Preço" select />

              <t-input cols="4" required v-model="form.customerSince" label="Cliente desde" date-now date/>


            </b-row>

            <b-row>

              <t-input v-model="form.contactName" cols="3"
                       class-icon-group="icon-mail-colored" label="Contato - Nome">
                <template #input-icon>
                  <b-icon-people/>
                </template>
              </t-input>

              <t-input v-model="form.contactEmail" cols="3"
                       class-icon-group="icon-mail-colored" email-multiple label="Contato - Email">
                <template #input-icon>
                  <b-icon-envelope/>
                </template>
              </t-input>

              <t-input v-model="form.contactDepartment" cols="3" label="Contato - Cargo/Representante Legal">

              </t-input>

              <t-input v-model="form.whatsapp" cols="3"
                       class-icon-group="icon-whatsapp-colored" tel label="WhatsApp">
                <template #input-icon>
                  <b-icon-whatsapp/>
                </template>
              </t-input>

            </b-row>


            <b-row>

              <t-input v-model="form.site" cols="3" class-icon-group="icon-mail-colored" url label="Site">
                <template #input-icon>
                  <b-icon-link/>
                </template>
              </t-input>

              <t-input v-model="form.instagram" small="Preencha no padrão @..." cols="3"
                       class-icon-group="icon-mail-colored" label="Instagram">
                <template #input-icon>
                  <b-icon-instagram/>
                </template>
              </t-input>

              <t-input v-model="form.linkedin" small="Preencha no padrão in/..." cols="3"
                       class-icon-group="icon-mail-colored" label="LinkedIn">
                <template #input-icon>
                  <b-icon-linkedin/>
                </template>
              </t-input>


              <t-input v-model="form.phone" cols="3" class-icon-group="icon-mail-colored" tel label="Telefone fixo">
                <template #input-icon>
                  <b-icon-telephone/>
                </template>
              </t-input>

            </b-row>

            <t-page-form-field-customized
                ref="fieldsGeneral"
                :command="command" :status="status" :user-auth="userAuth"
                :fields-customizable="entityFieldCustomized('page')"
                :primary-key="form.customerId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
                :primary-key-column="fieldKey" foreign-key-column="pageId"
            />

            <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

            <t-input-status text="Cliente" class="ml-1" v-model="form.status"/>

          </t-form-card>

        </t-form-tab>

      </template>


    </t-page-form>

  </t-page>

</template>
<script>

import TypeCustomerDialog from "@/views/modules/customer/TypeProfileDialog"
import GroupCostumerDialog from "@/views/modules/customer/GroupCostumerDialog"

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ePerson from "@/views/embed/general/e-person"
import eAddress from "@/views/embed/general/e-address"

import http from "@/services/config/http-common"
import pageFormEmbeddableMixin from "@/mixins/page/pageFormEmbeddableMixin";
import TypeOriginCustomerDialog from "@/views/modules/customer/TypeOriginDialog";
import pageViewService from "@/services/modules/setting/PageView.service";
import CompanyService from "@/services/modules/admin/Company.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormEmbeddableMixin],
  components: {
    ePerson,
    eAddress,
    TypeCustomerDialog,
    GroupCostumerDialog,
    TypeOriginCustomerDialog
  },
  name: 'CustomerFormArchEmbeddable',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: true,
      fieldKey: "customerId",
      enableGeneralFields: true,
      /*FORM DECLARADO NO MIXIM PARA VIR DE FORA COM OS CAMPOS PADRÕES JUNTOS COM OS CUSTOMIZADOS*/
      error: {//Campos que podem receber retorno de erro do backend
        otherCodeLabel: "",
        typeCustomerId: "",
        customerGroupId: "",
        companyId: "",
      },
      /*Embed Person Errors version: 1.0*/
      error_person: {
        name: "",
        federalTaxpayer: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      noOptionAdd: "", //Usado para armazenar o começo do nome digitado para inserção rápida em dialogos na página.
      companyOptions: [],
      typeOriginCustomerOptions: [],
      priceListOptions: [],
      typeCustomerOptions: [],
      customerGroupOptions: [],
      companiesIds: [],
      companiesList: [],
      viewFieldsPageCompanies: [],
      //--------------------------------------------------------------------------------------
    }
  },

  methods: {

    mountedPrepare() {
      this.mountedPrepareEmbeddable() //Sempre no início de mountedPrepare
    },
    async mountedContinued() {

      const account = await this.$store.getters.getAccountUser

      if(this.isInsert()){

        this.form.enableAllCompanies = account.enableAllCompanies

        if(!this.form.enableAllCompanies){
          this.form.companies = account.companies
        }

      }

      await http.list("customer/selectRelationList").then((response) => {

        this.companyOptions = response.companyOptions
        this.typeCustomerOptions = response.typeCustomerOptions
        this.priceListOptions = response.priceListOptions
        this.customerGroupOptions = response.customerGroupOptions
        this.typeOriginCustomerOptions = response.typeOriginCustomerOptions

      }).catch(error => this.responseError(error))

      await pageViewService.getViewFieldsByPage(31, true, [""]).then((response) => {
        this.viewFieldsPageCompanies = response
      }).catch(error => this.responseError(error))

      await CompanyService.getAllCompanies().then((list) => {
        this.companiesList = list
        this.companiesIds = this.convertObjectToArrayIds(this.form.companies, "companyId")
      }).catch(error => this.responseError(error))




      this.mountedContinuedEmbeddable() //Sempre no final de mountedContinued

    },
    async onSubmit(){

      this.form.companies = await this.convertArrayIdsToObject(this.companiesIds, "companyId")

      if (this.enabledSubmit) {
        await this.sendingFormDefault()
      } else {
        await this.$emit("beforeSubmit")
      }
    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onTypeCustomerDialog(itemInserted) {

      this.form.typeCustomerId = itemInserted.value
      this.typeCustomerOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    onGroupCostumerDialog(itemInserted) {

      this.form.customerGroupId = itemInserted.value
      this.customerGroupOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },

    onTypeOriginCustomerDialog(itemInserted) {

      this.form.typeOriginCustomerId = itemInserted.value
      this.typeOriginCustomerOptions.push(itemInserted); //Simples, pois é uma lista não agrupada

    },


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>
